var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57145 2.39999V21.6M17.4857 10.6286H12.6857M17.4857 6.51428H12.6857M5.14288 6.51428H2.40002M5.14288 10.6286H2.40002M5.14288 14.7428H2.40002M6.51431 21.6H18.8572C20.372 21.6 21.6 20.372 21.6 18.8571V5.14285C21.6 3.62801 20.372 2.39999 18.8572 2.39999H6.51431C4.99947 2.39999 3.77145 3.62801 3.77145 5.14285V18.8571C3.77145 20.372 4.99947 21.6 6.51431 21.6Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoca);
export default __webpack_public_path__ + "static/media/voca.277dea9e4e0c6be5c2c7fc166a2b5a45.svg";
export { ForwardRef as ReactComponent };